<script setup lang="ts">
import vReveal from "@/application/directives/vReveal";
</script>

<template>
  <section id="contact" class="cta-wrap">
    <VContainer class="landing-container">
      <div v-reveal class="cta">
        <p class="landing-eyebrow cta__eyebrow">Aan de slag</p>
        <h2 class="landing-h2 cta__title">
          Klaar om die vrijwilligers-groepsapp op te heffen?
        </h2>
        <p class="landing-lede cta__lede mt-3 mx-auto">
          Vertel ons kort over je club en we laten Klupz zien met jullie eigen
          taken en categorieën.
        </p>

        <div class="d-flex justify-center mt-8">
          <VBtn
            color="primary"
            size="large"
            variant="flat"
            append-icon="$arrowRight"
            href="mailto:info@bytechnology.nl?subject=Demo%20Klupz%20aanvragen"
          >
            Demo aanvragen
          </VBtn>
        </div>

        <p class="cta__contact mt-4">
          <a href="mailto:info@bytechnology.nl">info@bytechnology.nl</a>
          <span class="cta__contact-sep">·</span>
          <a href="tel:0762045123">076 - 204 51 23</a>
        </p>
      </div>
    </VContainer>
  </section>
</template>

<style scoped lang="scss">
.cta-wrap {
  padding: 8px 0 56px;
}

.cta {
  position: relative;
  overflow: hidden;
  border-radius: 28px;
  padding: 64px 32px;
  text-align: center;
  background: rgb(var(--v-theme-font-color));

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    z-index: 0;
  }

  &::before {
    inset: -45% -10% auto auto;
    width: 480px;
    height: 480px;
    background: radial-gradient(
      circle,
      rgba(76, 156, 219, 0.35),
      transparent 70%
    );
  }

  &::after {
    inset: auto auto -50% -10%;
    width: 420px;
    height: 420px;
    background: radial-gradient(
      circle,
      rgba(246, 134, 21, 0.22),
      transparent 70%
    );
  }
}

.cta__eyebrow {
  color: #93c5fd;
}

.cta__title,
.cta__lede,
.cta__contact {
  position: relative;
  z-index: 1;
}

.cta__title {
  max-width: 26ch;
  margin: 12px auto 0;
  color: #f1f5f9;
}

.cta__lede {
  color: #b9c3d8;
  max-width: 42ch;
}

.cta__contact {
  font-size: 14px;
  color: #b9c3d8;

  a {
    color: #f1f5f9;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
}

.cta__contact-sep {
  margin: 0 8px;
}
</style>
